export default new Intl.NumberFormat("de-DE", {
	style: "currency",
	currency: "EUR"
});
